import LabelContainer from '../label-container';
import ErrorContainer from '../error-container';

export default function InputsCounter(props) {
    const { label, placeholder, fill, value = 0, min = 0, max = null, onChange } = props;

    const maxString = max !== null ? `/${ max }` : '';

    return (
        <LabelContainer label={label} placeholder={placeholder} fill={fill}>
            <ErrorContainer errors={props?.errors}>
                <div className="counter">
                    <div className="counter__button" onClick={() => {
                        if (value > min) onChange(value - 1);
                    }}>-</div>
                    <p>{ value }{ maxString }</p>
                    <div className="counter__button" onClick={() => {
                        if (max === null) return onChange(value + 1);
                        if (value < max) return onChange(value + 1);
                        
                        if (value !== null && value === max) return; 

                        onChange(value + 1);
                    }}>+</div>
                </div>
            </ErrorContainer>
        </LabelContainer>
    )
}